import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ArtifactId, ProjectId, TestRunId, UserId} from '@webmate-web-core/shared/types/ids';
import {TestEmailAccount} from '@webmate-web-core/shared/types/testmgmt';
import {TestmailApi} from '@webmate-web-core/shared/api/rest/testmail.api';
import {ArtifactService} from '@webmate-web-core/shared/services/artifact.service';
import {filter, map} from 'rxjs/operators';
import {EventsService, WebmateWebsocketEvent} from '@webmate-web-core/shared/services/events/events.service';

@Injectable({
    providedIn: 'root'
})
export class TestMailService {

    constructor(private api: TestmailApi,
                private artifactService: ArtifactService,
                private eventService: EventsService) {
    }

    createTestMail(projectId: ProjectId, testRunId?: TestRunId): Observable<TestEmailAccount> {
        return this.api.createTestMail(projectId, testRunId);
    }

    getTestMailAccounts(projectId: ProjectId, testRunId?: TestRunId, user?: UserId): Observable<TestEmailAccount[]> {
        return this.api.getTestMailAccounts(projectId, testRunId, user);
    }

    getProjectMailArtifacts(projectId: ProjectId) {
        return this.artifactService.getArtifactsInProject$(projectId, undefined, ['Mail.MailContent']);
    }

    getMailArtifacts(ids: ArtifactId[]){
        return this.artifactService.getArtifacts$(ids);
    }

    getMailArtifact(id: ArtifactId) {
        return this.artifactService.getArtifact$(id);
    }

    getNewMailNotification(projectId: ProjectId): Observable<WebmateWebsocketEvent> {
        return this.eventService.getEventsForProject(projectId).pipe(filter(e => e.eventType === "TestMail.Mail.Received"));
    }
}
